export function fetchBargainWarehouseProducts(apiUrl, accessToken) {

  return fetch(`${apiUrl}/v1/bargain-warehouse`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })

}

export function fetchBargainWarehouseParts(apiUrl, accessToken) {

  return fetch(`${apiUrl}/v1/bargain-warehouse/parts`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })

}

export function fetchBwListing(apiUrl, accessToken, nid) {

  return fetch(`${apiUrl}/v1/bargain-warehouse/${nid}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })

}

export function fetchBwPartListing(apiUrl, accessToken, nid) {

  return fetch(`${apiUrl}/v1/bargain-warehouse/parts/${nid}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })

}